import { type OpenAPIV3 } from 'openapi-types';

export const AppWebhookSecret: OpenAPIV3.NonArraySchemaObject = {
  type: 'object',
  description: 'App webhook secret settings',
  additionalProperties: false,
  properties: {
    id: {
      type: 'number',
      description: 'An autogenerated ID.',
      readOnly: true,
    },
    name: {
      type: 'string',
      description: 'An optional name to give extra clarity what the secret is used for.',
    },
    webhookName: {
      type: 'string',
      description: 'The name of the webhook the secret is tied to',
    },
    secret: {
      type: 'string',
      description: 'The autogenerated secret to authenticate the webhook caller with.',
    },
  },
};
